import * as _warehouseServices from './warehouseServices'
import * as _loginServices from './loginServices'
import * as _policyServices from './policyServices'
import * as _stagingRecordServices from './stagingRecordServices'


export const warehouseServices = _warehouseServices
export const loginServices = _loginServices
export const policyServices = _policyServices
export const stagingRecordServices = _stagingRecordServices



// WEBPACK FOOTER //
// ./src/services/index.js